import React from 'react'
import clsx from 'clsx'
import { TickCircle, CloseCircle } from 'iconsax-react'

import useStyles from './styles'

const ButtonIcon = ({ variant }) => {
  if (variant === 'error')
    return <CloseCircle color='#FF3B3B' size='16' variant='Bold' />
  return <TickCircle color='#06C270' size='16' variant='Bold' />
}
const ConversationListActionButton = ({
  children,
  className,
  variant = 'success',
  ...rest
}) => {
  const classes = useStyles({ variant })
  return (
    <button
      className={clsx(classes.button, className ? className : '')}
      {...rest}
    >
      <ButtonIcon variant={variant} />
      {children}
    </button>
  )
}

export default ConversationListActionButton
